/* eslint-disable */
import { PayrollManagerCaseListDto, fixPayrollManagerCaseListDtoFromJson, fixPayrollManagerCaseListDtoToJson } from '../dto/payroll-manager-case-list-dto';

export interface PayrollManagerCustomerSupportInformationDto {
  name: string;
  eMail?: string | null;
  servicePackage?: string | null;
  jTelClassification?: string | null;
  chiefInstruction?: string | null;
  cases: PayrollManagerCaseListDto[];
}

export const fixPayrollManagerCustomerSupportInformationDtoFromJson = (dto?: PayrollManagerCustomerSupportInformationDto | null): void => {
  if (!dto) {
    return;
  }
  dto.cases?.forEach((x, i, a) => fixPayrollManagerCaseListDtoFromJson(a[i]));
};

export const fixPayrollManagerCustomerSupportInformationDtoToJson = (dto?: PayrollManagerCustomerSupportInformationDto | null): void => {
  if (!dto) {
    return;
  }
  dto.cases?.forEach((x, i, a) => fixPayrollManagerCaseListDtoToJson(a[i]));
};
